// app.js

document.addEventListener('DOMContentLoaded', function () {
  // ==============================
  // 1) モバイルメニュー（data属性ベース）
  // ==============================
  var toggle = document.querySelector('[data-menu-toggle]');
  var panel  = document.querySelector('[data-menu-panel]');
  if (toggle && panel) {
    toggle.addEventListener('click', function () {
      var expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!expanded));
      panel.classList.toggle('hidden');
    });
  }

  // ==============================
  // 2) スムーススクロール（#anchor）
  // ==============================
  var links = document.querySelectorAll('a[href^="#"]');
  links.forEach(function (a) {
    a.addEventListener('click', function (e) {
      var id = a.getAttribute('href');
      if (id && id.length > 1) {
        var target = document.querySelector(id);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    });
  });

  // ==============================
  // 3) ヘッダー固定時のシャドウ付与
  // ==============================
  var header = document.getElementById('site-header') || document.querySelector('header.sticky, header.fixed, header[data-sticky]');
  var topSection = document.querySelector('#top');
  if (header && topSection) {
    var onScrollHeader = function () {
      var threshold = 8; // scroll a few px then switch to solid header
      var scrolled = window.scrollY > threshold;
      header.classList.toggle('bg-white', scrolled);
      header.classList.toggle('shadow-md', scrolled);
      header.classList.toggle('bg-transparent', !scrolled);
    };
    window.addEventListener('scroll', onScrollHeader, { passive: true });
    onScrollHeader();
  }

  // ==============================
  // 4) fade-in-up アニメーション
  // ==============================
  var fadeItems = document.querySelectorAll('.fade-in-up');
  if (fadeItems.length) {
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries, observer) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        },
        {
          threshold: 0.2
        }
      );

      fadeItems.forEach(function (el) {
        io.observe(el);
      });
    } else {
      fadeItems.forEach(function (el) {
        el.classList.add('is-visible');
      });
    }
  }

  // ==============================
  // 5) ハンバーガーメニュー（IDベース）
  // ==============================
  (function () {
    var btn      = document.getElementById('hamburger-button');
    var closeBtn = document.getElementById('close-button');
    var nav      = document.getElementById('mobile-menu');
    var overlay  = document.getElementById('menu-overlay');
    var body     = document.body;
    if (!btn || !nav || !overlay) return;

    var DURATION = 300;

    var iconBurger = btn.querySelector('[data-icon="burger"]');
    var iconClose  = btn.querySelector('[data-icon="close"]');

    function showIcons(open) {
      if (!iconBurger || !iconClose) return;
      iconBurger.classList.toggle('hidden', open);
      iconClose.classList.toggle('hidden', !open);
    }

    function openMenu() {
      nav.hidden = false;
      overlay.hidden = false;

      requestAnimationFrame(function () {
        nav.classList.remove('translate-x-full');
        overlay.classList.remove('opacity-0', 'pointer-events-none');
      });

      btn.setAttribute('aria-expanded', 'true');
      body.classList.add('overflow-hidden');
      showIcons(true);
    }

    function closeMenu() {
      nav.classList.add('translate-x-full');
      overlay.classList.add('opacity-0', 'pointer-events-none');

      btn.setAttribute('aria-expanded', 'false');
      body.classList.remove('overflow-hidden');
      showIcons(false);

      setTimeout(function () {
        if (btn.getAttribute('aria-expanded') === 'false') {
          nav.hidden = true;
          overlay.hidden = true;
        }
      }, DURATION);
    }

    btn.addEventListener('click', function () {
      var open = btn.getAttribute('aria-expanded') === 'true';
      if (open) {
        closeMenu();
      } else {
        openMenu();
      }
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', closeMenu);
    }

    overlay.addEventListener('click', closeMenu);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && btn.getAttribute('aria-expanded') === 'true') {
        closeMenu();
      }
    });
    nav.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', closeMenu);
    });
  })();

  // ==============================
  // 6) Service スライダー（SPのみ有効）
  // ==============================
  initServiceSlider();
});


// =========================================
// Service スライダー本体（前と同じ）
// =========================================
function initServiceSlider() {
  var root = document.querySelector('[data-slider]');
  if (!root) return;

  var track    = root.querySelector('[data-slider-track]');
  var dotsWrap = root.querySelector('[data-dots]');
  var mq       = window.matchMedia('(min-width: 1024px)'); // lg 以上は無効

  var AUTOPLAY_MS     = 3000;
  var SWIPE_THRESHOLD = 0.15;

  var originalSlides = [];
  var slides = [];
  var index = 1;
  var enabled = false;
  var timer = null;
  var isDown = false, startX = 0, deltaX = 0;
  var ro = null;

  // ---- 高さ揃え ----
  function equalizeHeights() {
    var cards = originalSlides.map(function (s) { return s.firstElementChild; }).filter(Boolean);
    if (cards.length === 0) return;

    cards.forEach(function (c) { c.style.minHeight = ''; });

    var maxH = 0;
    cards.forEach(function (c) {
      var h = c.offsetHeight || c.scrollHeight || 0;
      if (h > maxH) maxH = h;
    });

    cards.forEach(function (c) { c.style.minHeight = maxH + 'px'; });
    slides.forEach(function (s) {
      var card = s.firstElementChild;
      if (card) card.style.minHeight = maxH + 'px';
    });
  }

  // ---- クローン構築 ----
  function buildClones() {
    var children = Array.from(track.children);
    children.forEach(function (ch) { ch.remove(); });

    originalSlides.forEach(function (s) { track.appendChild(s); });

    var firstClone = originalSlides[0].cloneNode(true);
    var lastClone  = originalSlides[originalSlides.length - 1].cloneNode(true);

    track.insertBefore(lastClone, track.firstChild);
    track.appendChild(firstClone);

    slides = Array.from(track.children);
    index = 1;
    applyTranslate(true);
  }

  // ---- ドット ----
  function buildDots() {
    if (!dotsWrap) return;
    dotsWrap.innerHTML = '';

    originalSlides.forEach(function (_, i) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'w-2.5 h-2.5 rounded-full bg-gray-300 aria-[current=true]:bg-gray-800 transition-colors';
      dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
      dot.addEventListener('click', function () { goTo(i); });
      dotsWrap.appendChild(dot);
    });

    updateDots();
  }

  function updateDots() {
    if (!dotsWrap) return;
    var n = originalSlides.length;
    var real = (index - 1 + n) % n;

    Array.prototype.forEach.call(dotsWrap.children, function (d, i) {
      d.setAttribute('aria-current', i === real ? 'true' : 'false');
    });
  }

  // ---- 位置制御 ----
  function applyTranslate(noAnim) {
    if (noAnim) {
      var prev = track.style.transition;
      track.style.transition = 'none';
      track.style.transform = 'translateX(' + (-index * 100) + '%)';
      track.offsetHeight;
      track.style.transition = prev || '';
    } else {
      track.style.transform = 'translateX(' + (-index * 100) + '%)';
    }
    updateDots();
  }

  function getRealIndex() {
    var n = originalSlides.length;
    return (index - 1 + n) % n;
  }

  function goTo(realIdx) {
    index = realIdx + 1;
    applyTranslate();
  }

  function goToReal(realIdx) {
    index = realIdx + 1;
    applyTranslate();
  }

  // ---- transitionend で無限ループスナップ ----
  function onTransitionEnd(e) {
    if (e.target !== track || e.propertyName !== 'transform') return;
    var n = originalSlides.length;
    if (index === 0) {
      index = n;
      applyTranslate(true);
    } else if (index === n + 1) {
      index = 1;
      applyTranslate(true);
    }
  }

  // ---- 自動再生 ----
  function startAuto() {
    stopAuto();
    timer = setInterval(function () {
      index++;
      applyTranslate();
    }, AUTOPLAY_MS);
  }
  function stopAuto() {
    if (timer) {
      clearInterval(timer);
      timer = null;
    }
  }

  // ---- スワイプ ----
  function getClientX(e) {
    if (e.touches && e.touches[0]) return e.touches[0].clientX;
    if (typeof e.clientX === 'number') return e.clientX;
    return 0;
  }

  function onPointerDown(e) {
    if (!enabled) return;
    isDown = true;
    startX = getClientX(e);
    deltaX = 0;
    track.dataset._prevTransition = track.style.transition;
    track.style.transition = 'none';
    stopAuto();
  }

  function onPointerMove(e) {
    if (!enabled || !isDown) return;
    var x = getClientX(e);
    deltaX = x - startX;
    var width = root.clientWidth || 1;
    var percent = (deltaX / width) * 100;
    track.style.transform = 'translateX(' + (-(index * 100) + percent) + '%)';
  }

  function onPointerUp() {
    if (!enabled || !isDown) return;
    isDown = false;

    track.style.transition = track.dataset._prevTransition || '';
    delete track.dataset._prevTransition;

    var width = root.clientWidth || 1;
    var threshold = width * SWIPE_THRESHOLD;
    if (deltaX > threshold) {
      index--;
    } else if (deltaX < -threshold) {
      index++;
    }
    deltaX = 0;
    applyTranslate();
    startAuto();
  }

  // ---- 有効化/無効化 ----
  function enable() {
    if (enabled) return;
    enabled = true;

    originalSlides = Array.from(track.children);
    if (originalSlides.length <= 1) return;

    buildClones();
    buildDots();
    equalizeHeights();

    track.addEventListener('transitionend', onTransitionEnd);
    root.addEventListener('mouseenter', stopAuto);
    root.addEventListener('mouseleave', startAuto);
    root.addEventListener('touchstart', stopAuto, { passive: true });
    root.addEventListener('touchend', startAuto);

    track.addEventListener('pointerdown', onPointerDown);
    window.addEventListener('pointermove', onPointerMove);
    window.addEventListener('pointerup', onPointerUp);

    track.addEventListener('touchstart', onPointerDown, { passive: true });
    window.addEventListener('touchmove', onPointerMove, { passive: true });
    window.addEventListener('touchend', onPointerUp);

    window.addEventListener('resize', onResize);

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(equalizeHeights);
    }
    window.addEventListener('load', equalizeHeights);

    if ('ResizeObserver' in window) {
      ro = new ResizeObserver(equalizeHeights);
      ro.observe(track);
      root._ro = ro;
    }

    startAuto();
  }

  function disable() {
    if (!enabled) return;
    enabled = false;

    stopAuto();

    track.removeEventListener('transitionend', onTransitionEnd);
    root.removeEventListener('mouseenter', stopAuto);
    root.removeEventListener('mouseleave', startAuto);
    root.removeEventListener('touchstart', stopAuto);
    root.removeEventListener('touchend', startAuto);

    track.removeEventListener('pointerdown', onPointerDown);
    window.removeEventListener('pointermove', onPointerMove);
    window.removeEventListener('pointerup', onPointerUp);

    track.removeEventListener('touchstart', onPointerDown);
    window.removeEventListener('touchmove', onPointerMove);
    window.removeEventListener('touchend', onPointerUp);

    window.removeEventListener('resize', onResize);

    if (root._ro) {
      root._ro.disconnect();
      root._ro = null;
    }

    var current = Array.from(track.children);
    track.innerHTML = '';
    originalSlides.forEach(function (s) { track.appendChild(s); });

    if (dotsWrap) dotsWrap.innerHTML = '';
    track.style.transform = '';
  }

  function onResize() {
    if (!enabled) return;
    applyTranslate(true);
    equalizeHeights();
  }

  function applyMode() {
    if (mq.matches) {
      disable(); // PC
    } else {
      enable();  // SP
    }
  }

  if (mq.addEventListener) {
    mq.addEventListener('change', applyMode);
  } else if (mq.addListener) {
    mq.addListener(applyMode);
  }

  applyMode();
}

document.addEventListener("DOMContentLoaded", () => {
    const header = document.getElementById("site-header");
    const topSection = document.getElementById("top");

    if (!header || !topSection) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // #top がまだ見えている → 透明ヘッダー
        header.classList.remove("bg-white", "shadow-md");
        header.classList.add("bg-transparent");
      } else {
        // #top を抜けた → 白背景ヘッダー
        header.classList.add("bg-white", "shadow-md");
        header.classList.remove("bg-transparent");
      }
        });
      },
      {
        // 下方向に少しだけ余裕を見て切り替えたい場合はここで調整
        root: null,
        threshold: 0,
        rootMargin: "0px 0px -80px 0px", // ヘッダーの高さぶんくらいマイナスにすると自然
      }
    );

    observer.observe(topSection);
  });
